import React from "react";
import { IconButton, Popover, Portal, Tabs } from "@chakra-ui/react";
import { LuSettings } from "react-icons/lu";
import { serviceGetOrUpdateSettings } from "../../../api/services/settings";
import SettingsMenuHotKeys from "./SettingsMenuHotKeys";
import { useAppStore } from "../../../context/store";

import SettingsMenuEditing from "./SettingsMenuEditing";
import SettingsMenuGeneral from "./SettingsMenuGeneral";
import SettingsMenuNodeHeight from "./SettingsMenuNodeHeight";
import SettingsMenuSpeedProfileRange from "./SettingsMenuSpeedProfileRange";
import SettingsMenuDefaultGeojsonStyle from "./SettingsMenuDefaultGeojsonStyle";
import SettingsMenuDefaultBasicGeojsonStyle from "./SettingsMenuDefaultBasicGeojsonStyle";
import SettingsMenuDefaultOsmStyle from "./SettingsMenuDefaultOsmStyle";
import { Tooltip } from "../../../components/ui/tooltip";

function SettingMenu() {
  // ===== state =====
  const defaultGeojsonStyle = useAppStore((s) => s.defaultGeojsonStyle);
  const snappingOptions = useAppStore((s) => s.snappingOptions);
  const basicGeojsonStyle = useAppStore((s) => s.basicGeojsonStyle);
  const configSpeedProfile = useAppStore((s) => s.configSpeedProfile);
  const defaultOsmStyle = useAppStore((s) => s.defaultOsmStyle);
  const directionArrowSetting = useAppStore((s) => s.directionArrowSetting);
  const db = useAppStore((s) => s.db);
  const defaultCity = useAppStore((s) => s.defaultCity);
  const userData = useAppStore((s) => s.userData);
  const filterNodeMinHeight = useAppStore((s) => s.filterNodeMinHeight);
  const filterNodeMaxHeight = useAppStore((s) => s.filterNodeMaxHeight);
  const simplifyToleranceSetting = useAppStore((s) => s.simplifyToleranceSetting);

  const updateUserSettingsToServer = () => {
    const data = {
      ...snappingOptions,
      ...directionArrowSetting,
      database: db,
      city: defaultCity,
      speed_profile: configSpeedProfile,
      min_height: filterNodeMinHeight,
      max_height: filterNodeMaxHeight,
      default_geojson_style: defaultGeojsonStyle,
      basic_geojson_style: basicGeojsonStyle,
      default_osm_style: defaultOsmStyle,
      simplify_tolerance: simplifyToleranceSetting,
    };

    const formData = new FormData();
    formData.append("settings_data", JSON.stringify(data));

    serviceGetOrUpdateSettings(formData, userData.token)
      .then((res) => {})
      .catch((err) => {
        console.error("Error", err);
      });
  };

  return (
    <Popover.Root
      positioning={{ placement: "bottom-end" }}
      size={"lg"}
      onOpenChange={(e) => {
        if (!e.open) updateUserSettingsToServer();
      }}
    >
      <Popover.Trigger asChild>
        <IconButton userSelect={"none"} rounded="full" boxShadow="lg" bg={"Background"}>
          <Tooltip content="Settings">
            <LuSettings color="MenuText" />
          </Tooltip>
        </IconButton>
      </Popover.Trigger>
      <Portal width={"450px"}>
        <Popover.Positioner>
          <Popover.Content width={"fit-content"}>
            <Popover.Arrow />
            <Popover.Body p={2}>
              <Tabs.Root defaultValue="general">
                <Tabs.List>
                  <Tabs.Trigger value="hot_keys">Hot Keys</Tabs.Trigger>
                  <Tabs.Trigger value="general">General</Tabs.Trigger>
                  <Tabs.Trigger value="editing">Editing</Tabs.Trigger>
                  <Tabs.Trigger value="speed_limit">Speed Profile Range</Tabs.Trigger>
                  <Tabs.Trigger value="node_height">Node Height</Tabs.Trigger>
                  <Tabs.Trigger value="default_geojson_style">Default Geojson Style</Tabs.Trigger>
                  <Tabs.Trigger value="default_basic_geojson_style">HD Map Geojson Style</Tabs.Trigger>
                  <Tabs.Trigger value="default_osm_style">OSM Style</Tabs.Trigger>
                </Tabs.List>
                <Tabs.Content value="hot_keys" maxHeight={"75vh"} overflowY={"auto"}>
                  <SettingsMenuHotKeys />
                </Tabs.Content>
                <Tabs.Content value="general" maxHeight={"75vh"} overflowY={"auto"}>
                  <SettingsMenuGeneral />
                </Tabs.Content>
                <Tabs.Content value="editing" maxHeight={"75vh"} overflowY={"auto"}>
                  <SettingsMenuEditing />
                </Tabs.Content>
                <Tabs.Content value="speed_limit" maxHeight={"75vh"} overflowY={"auto"}>
                  <SettingsMenuSpeedProfileRange />
                </Tabs.Content>
                <Tabs.Content value="node_height" maxHeight={"75vh"} overflowY={"auto"}>
                  <SettingsMenuNodeHeight />
                </Tabs.Content>
                <Tabs.Content value="default_geojson_style" maxHeight={"75vh"} overflowY={"auto"}>
                  <SettingsMenuDefaultGeojsonStyle />
                </Tabs.Content>
                <Tabs.Content value="default_basic_geojson_style" maxHeight={"75vh"} overflowY={"auto"}>
                  <SettingsMenuDefaultBasicGeojsonStyle />
                </Tabs.Content>
                <Tabs.Content value="default_osm_style" maxHeight={"75vh"} overflowY={"auto"}>
                  <SettingsMenuDefaultOsmStyle />
                </Tabs.Content>
              </Tabs.Root>
            </Popover.Body>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
}

export default SettingMenu;
